"use client";

import { Link } from "@/components/common/Link";
import { Facebook, Instagram, Linkedin, MessageSquare } from "lucide-react";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="w-full bg-dark-background py-12">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {}
          <div className="text-foreground-dark text-sm order-2 md:order-1 text-center md:text-left">
            <div className="mb-2">Bogotá, Colombia

          </div>
            <div>©Aerolimpio 2026. Todos los derechos reservados. El servicio de limpieza con drones está orientado a mantenimiento preventivo y limpieza profesional de superficies en altura. El resultado final depende del estado previo de la superficie y del tipo de suciedad acumulada. En casos de suciedad severa o deterioro avanzado, pueden ser necesarias soluciones complementarias.</div>
          </div>

          {}
          <div className="flex items-center gap-4 order-1 md:order-2">
            <Link to="https://facebook.com" newTab className="text-foreground-dark hover:text-primary transition-colors duration-200 hover:animate-pulse" aria-label="Facebook">
              <Facebook className="size-5" />
            </Link>
            <Link to="https://instagram.com" newTab className="text-foreground-dark hover:text-primary transition-colors duration-200 hover:animate-pulse" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
            <Link to="https://linkedin.com" newTab className="text-foreground-dark hover:text-primary transition-colors duration-200 hover:animate-pulse" aria-label="LinkedIn">
              <Linkedin className="size-5" />
            </Link>
            <Link to="https://wa.me/573162738270" newTab className="text-foreground-dark hover:text-primary transition-colors duration-200 hover:animate-pulse" aria-label="WhatsApp">
              <MessageSquare className="size-5" />
            </Link>
          </div>

          {}
          <nav className="flex items-center gap-6 order-3" aria-label="Footer navigation">
            <Link to="/PoliticaDePrivacidad" className="text-foreground-dark text-sm relative hover:text-primary transition-colors duration-200 after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-primary after:transition-all after:duration-200 hover:after:w-full">
              Privacidad
            </Link>
            <Link to="#" className="text-foreground-dark text-sm relative hover:text-primary transition-colors duration-200 after:absolute after:bottom-0 after:left-0 after:h-0.5 after:w-0 after:bg-primary after:transition-all after:duration-200 hover:after:w-full">
              Términos y Condiciones
            </Link>
            
          </nav>
        </div>
      </div>
    </footer>;
}